export const FILE_TYPES = Object.freeze({
	CC: 'cc',
	ATTACHMENT: 'attachment',
});
